export default (settings: any) => settings['searchFields'] * (1 / 60) * 20
